import { Api } from "@/models/class/api.class";
import { Pagination } from "@/models/constant/interface/common.interface";
import {
  ErrorResponseModel,
  RequestQueryParamsModel,
} from "@/models/interface/http.interface";
import { SegmentResponseDto } from "@/models/interface/master-asset";
import { AxiosError } from "axios";
import { HttpClient } from "./HttpClient.service";

class AssetSegmentService extends HttpClient {
  getSegmentParent(
    params?: RequestQueryParamsModel
  ): Promise<Pagination<SegmentResponseDto>> {
    return this.get<Pagination<SegmentResponseDto>>(Api.AssetSegmentParent, {
      params,
    })
      .then(this.success)
      .catch((error: AxiosError<ErrorResponseModel>) => {
        throw this.error(error);
      });
  }
}

export const assetSegmentService = new AssetSegmentService();
